import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ajaxInventoryReports from "../../util/remote/ajaxInventoryReports";
// Register core Chart.js modules only
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
export default function CompanyStationFuelBalancesChart() {
  const company_id = Number(window.localStorage.getItem("FuelFy@company_id"));
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    if (!company_id) return;
    try {
      const response =
        await ajaxInventoryReports.Current_company_station_inventory_stock({
          company_id: company_id,
        });
      if (response.status !== "OK") {
        console.error("Failed to fetch data", response.message);
        setLoading(false);
        return;
      }
      const stations =
        Array.isArray(response.details) &&
        response.details.map((d) => d.station);
      const fuelTypes = Array.from(
        new Set(
          response.details.flatMap((item) =>
            Object.keys(item).filter((k) => k !== "station")
          )
        )
      );
      const COLORS = [
        "#13432bff",
        "#6abc6eff",
        "#4BC0C0",
        "#FF9F40",
        "#9966FF",
        "#d63384ff",
        "#98880cff",
        "#0c986eff",
      ];
      const datasets = fuelTypes.map((fuel, index) => ({
        label: fuel,
        data:
          Array.isArray(response.details) &&
          response.details.map((station) => station[fuel] || 0),
        backgroundColor: COLORS[index % COLORS.length], // <-- use COLORS array
        borderRadius: 5,
      }));
      setChartData({ labels: stations, datasets });
    } catch (err) {
      console.error("Error fetching chart data:", err);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  if (loading) return <div className="text-center p-4">Loading chart...</div>;
  if (!chartData)
    return <div className="text-center p-4">No data available</div>;
  return (
    <div className="p-6 bg-white rounded-2xl shadow w-full">
      <div style={{ width: "100%", height: "350px" }}>
        <Bar
          data={chartData}
          plugins={[ChartDataLabels]} // <-- register plugin locally
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { position: "bottom" },
              title: { display: true, text: "Fuel Balance per Station" },
              datalabels: {
                color: "#160202ff",
                anchor: "center",
                align: "center",
                font: { weight: "bold", size: 8 },
                formatter: (value) => value,
                rotation: -45,
              },
            },
            scales: {
              x: {
                stacked: false,
                barThickness: 8,
                maxBarThickness: 10,
                categoryPercentage: 0.5,
                barPercentage: 0.8,
              },
              y: {
                stacked: false,
              },
            },
          }}
        />
      </div>
    </div>
  );
}
